const dependency = {
  name: {
    label: "Nom",
    invalid: {}
  },
};

export default dependency;
